<ion-col size="12" *ngIf="valgtAnleggMaaned">
  <ion-row class="cost-info-row">
    <ion-col class="box-col-nokkeltall">
      <p>Strøm {{ selectedYear }}</p>
      <p class="large-number-total">{{ toRoundNumber(stromTotal) }} kr</p>
      <div class="flex-row">
        <p>Forbruk</p>
        <p>{{ toRoundNumber(stromForbrukbelop) }} kr</p>
      </div>
      <div class="flex-row">
        <p>Fastbeløp</p>
        <p>{{ toRoundNumber(stromFastbelop) }} kr</p>
      </div>
      <div class="flex-row" *ngIf="isPlusskunde">
        <p>Inntekter</p>
        <p>{{ toRoundNumber(inntektProd) }} kr</p>
      </div>
    </ion-col>
    <ion-col
      *ngIf="valgtAnleggMaaned.gjennomfakturering"
      class="box-col-nokkeltall"
    >
      <p>Nettleie {{ selectedYear }}</p>
      <p class="large-number-total">{{ toRoundNumber(nettleieTotal) }} kr</p>
      <div class="flex-row">
        <p>Forbruk</p>
        <p>{{ toRoundNumber(nettleieEnergiledd) }} kr</p>
      </div>
      <div class="flex-row">
        <p>Fastbeløp</p>
        <p>{{ toRoundNumber(nettleieFastbelop) }} kr</p>
      </div>
      <div class="flex-row">
        <p>Avgifter</p>
        <p>{{ toRoundNumber(nettleieAvgifter) }} kr</p>
      </div>
      <div class="flex-row">
        <p>Strømstøtte</p>
        <p>{{ toRoundNumber(stromstotteTotal) }} kr</p>
      </div>
    </ion-col>
  </ion-row>
</ion-col>
